import React, { useMemo } from 'react';
import styles from './index.module.scss';
import cls from 'classnames';
import { useProductKinds } from '@/stores';
import { useParams, useNavigate } from 'react-router-dom';
import { ActivityLayout } from '@/components/Layout/ActivityLayout';
import Fator from './Fator';
import ProductList from './ProductList';

// class_type 0：无、1：normal-一般商品、2：modal-模坑赏、3：hexapus-一番赏

const Mall = () => {
  const navigate = useNavigate();
  const routerParams = useParams();
  const { navProductKindList } = useProductKinds();
  const classInfo = useMemo(() => {
    return navProductKindList.find((item) => {
      const ename = (item.ename || '').replace(/\s*/g, '');
      return routerParams.mallid === ename;
    });
  }, [routerParams.mallid, navProductKindList]);
  // 找不到那个class_id了
  if (navProductKindList.length && routerParams.mallid && !classInfo) {
    navigate('/');
  }
  const isNormalProduct =
    classInfo && (classInfo.class_type === 0 || classInfo.class_type === 1);

  const Container =
    classInfo && !isNormalProduct ? ActivityLayout : React.Fragment;

  return (
    <Container>
      <div className={cls(styles.container, 'container')}>
        <div className={cls(styles.wrap)}>
          <Fator isNormalProduct={isNormalProduct} />
          <ProductList
            isNormalProduct={isNormalProduct}
            classInfo={classInfo}
          />
        </div>
      </div>
    </Container>
  );
};

export default Mall;
